import { useMemo } from 'react';
import { composeDecoders, decodeBoolean, decodeFloat } from '@cp/shared/queryParams';

export const useCatalogQSDecoder = () => useMemo(() => ({ decoder: composeDecoders(decodeFloat, decodeBoolean) }), []);
